<template>
	<carousel-content>
		<template #text>
			<h3>Arrivée des organisations !</h3>
			<p>
				Prenez de la hauteur et gérez au plus simple ou
				finement les autorisations de vos utilisateurs !
			</p>
			<p>
				Que vous travailliez sur une seule société ou tout un groupe, la
				<strong class="text--brand">
					nouvelle gestion des droits
				</strong>
				vous apporte plus de flexibilité que jamais.
				<br>
				Ainsi, cette mise à jour regroupe :
			</p>
			<ul>
				<li>Une toute nouvelle gestion des droits : <strong>les rôles</strong>.</li>
				<li>L'arrivée des <strong>tags</strong>, un moyen simple de cloisonner des utilisateurs à certains documents.</li>
				<li>La vision globale et schématique des liens qui relient utilisateurs et sociétés.</li>
			</ul>
			<o-button
				color="brand"
				@click="setup.handleOrganizationCarouselRedirection()">
				{{ setup.organizationCarouselButtonLabel }}
			</o-button>
		</template>
		<template #img>
			<div class="carousel-organization__perspective">
				<o-card
					class="carousel-organization__image">
					<organization-user-aside-details fake/>
				</o-card>
			</div>
		</template>
	</carousel-content>
</template>

<script setup lang="ts">
import CarouselOrganizationSetupService from '@/setup/carousel/CarouselOrganizationSetupService';
import CarouselContent from '@/components/carousel/CarouselContent.vue';
import OrganizationUserAsideDetails from '@/components/organization-user/OrganizationUserAsideDetails.vue';
const setup = new CarouselOrganizationSetupService();
</script>


<style lang="less">
@import '@/styles/variables';
.carousel-organization {

	&__perspective {
		background: var(--grey-lighter);
		border-radius: 2.5rem;
		height: 100%;
		pointer-events: none;
		position: relative;
		margin-top: 1.25rem;
		flex: 1;
		display: flex;
		overflow: hidden;
	}

	&__image {
		position: absolute;
		border-radius: 0.9rem;
		padding: 2.5rem;
		top: -3.75rem;
		transform-style: preserve-3d;
		transform-origin: top;
		transform: scale(0.6) rotateX(40deg) rotateZ(40deg);
		z-index: 2;
		display: none;

		@media @tablet {
			display: block;
			right: -100rem;
			top: -1.9rem;
		}

		@media @desktop, @layoutNavCollapsed {
      right: -16.5rem;
      top: 2.25rem;
		}
	}
}
</style>
